import { createStyles, makeStyles, Theme } from '../../../../../UI'

export default makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: '100%',
      // minWidth: '720px',
      borderRadius: '16px',
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: {
        margin: 0,
      }
    },
    container: {
      [theme.breakpoints.down('sm')]: {
        alignItems: 'flex-end',
      }
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      paddingBottom: '1rem',
      justifyContent: 'flex-end',
      position: 'absolute',
      right: 0,
      top: 0,
      padding: '8px 24px !important',
      zIndex: 9999,
      '@global': {
        '.MuiButton-label': {
          width: 'fit-content'
        }
      }
    },
    body: {
      // paddingBottom: '1rem'
    },
    text: {
      padding: '0',
      fontFamily: 'OutfitHeavy',
      textTransform: 'uppercase',
      textAlign: 'left'
    },
    boxes: {
      display: 'flex',
      // gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '1rem',
    },
    box: {
      display: 'flex',
      justifyContent: 'flex-start',
      flexDirection: 'column',
      alignItems: 'flex-start',
      width: '280px',
      textAlign: 'left',
      border: '2px solid #F5F6F7',
      borderRadius: 8,
      boxShadow: '0px 3px 5px rgba(26, 42, 85, 0.2), 0px 0px 1px rgba(26, 42, 85, 0.31)',
      padding: '8px',
      position: 'relative',
      cursor: 'pointer',
      '&:hover': {
        border: '2px solid var(--bosscat-blue-600)',
        transition: '300ms all',
        '@global': {
          '.MuiSvgIcon-root': {
            fill: 'var(--bosscat-blue-600)',
          }
        }
      }
    },
    noAbsolute: {
      position: 'relative'
    },
    radioButton: {
      position: 'absolute',
      right: '8px',
      padding: 0,
      width: 'fit-content',
      height: 'fit-content',
      minWidth: 'fit-content',
      '@global': {
        '.MuiButton-label': {
          width: 'fit-content'
        }
      }
    },
    title: {
      color: '#0B060F',
      fontSize: 18,
      marginBottom: '.5rem'
    },
    subtitle: {
      color: '#6D6A6F'
    },
    closeButton: {
      backgroundColor: 'var(--bosscat-grey-400) !important',
      width: 40,
      height: 40,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: 8,
      maxWidth: 40,
      boxShadow: '0px 3px 5px rgba(26, 42, 85, 0.2), 0px 0px 1px rgba(26, 42, 85, 0.31)',
      minWidth: 'fit-content',
      '@global': {
        '.MuiSvgIcon-root': {
          fontSize: '1rem'
        }
      }
    },
  })
)
